import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const SmileyFace = styled.div`
  /*CONTENT SMILE FACES*/
  text-align: center;
  padding-top: 0px;
  padding-bottom: 20px;
  background-color: ${(props) =>
    props?.backgroundColor ? "rgba(255,255,255,0.6)" : props.theme.neutral.gray[200]};
`;

export const GeneralFillOutSurvey = styled.div`
  .icon-selected-Survey-answer {
    height: 30px !important;
    width: 10% !important;
  }

  .redirection {
    padding: 1em;
    background-color: #f5edf5;
    max-width: 700px;
    height: auto;
    margin-top: 20px;
  }
`;

export const Background = styled.div`
  ${({ image }) => image && `background-image: url(${image});`}
  background-color : ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.neutral.white};

  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  /* height: 100vh; */
  width: 100%;
`;

export const ContentQuestions = styled.div`
  // height: 1000px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 300px;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: #4c244385;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
export const ContentTextBanner = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 0 14px 0;
  &::-webkit-scrollbar {
    height: 0.3rem;
  }
  &::-webkit-scrollbar-thumb {
    background: #de00acd9;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentInternal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .react-slidedown {
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
`;
export const GeneralStyleHead = styled.div`
  background-color: ${(props) => (props.color ? props.color : "transparent")};
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-self: center;
  margin: 1em auto;
  max-width: 700px;
  font-size: 14px;
  border-radius: 5px;
  width: 90vw;
  flex-direction: column;
  display: flex;

  img {
    vertical-align: middle;
    border-style: none;
    max-width: 700px;
    border-radius: 4px 4px 0px 0px;
  }

  a.hrref {
    color: ${({ theme }) => theme.button.primary};
    font-weight: 900;
  }
  p {
    padding: 0 !important;
    margin: 0 !important;
    word-wrap: break-word;
  }
`;

export const GeneralStyle = styled.div`
  background-color: ${(props) => (props.color ? props.color : theme.neutral.white)};
  border: ${(props) => (props.color ? "none" : `1px solid ${props.theme.text.disabled}`)};
  align-items: center;
  justify-self: center;
  display: grid;
  margin: 1em auto;
  max-width: 700px;
  min-height: 8em;
  // grid-template-columns: minmax(450px, auto);
  font-size: 14px;
  border-radius: 5px;
  padding: 1.5em 1.5em;
  word-break: break-word;
  width: 90vw;

  button {
    align-self: center;
    justify-self: right !important;
    margin-top: 5px;
  }

  h3 {
    grid-row: 1;
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
    margin: 0 0 9px 15px;
    font-size: 1.5em;
  }

  h2 {
    text-align: left;
    // margin: 0 0 9px 15px;
    margin: 7px 0px 0px 14px;
    font-size: 1.5em;
    color: ${({ theme }) => theme.primary.purple};
    font-size: 1em;
  }

  svg {
    // position: relative;
    // top: 5px;
    // right: 5px;
  }
`;

export const LowerWrapper = styled.div`
  display: grid;
  padding: 0.4em;
  grid-auto-rows: 0.1fr auto;
  align-items: center;
  textarea {
    resize: none;
    padding: 0.5em;
    width: 100%;
    border: none;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const Styletitle = styled.div`
  font-size: ${(props) => (props.size ? props.size : "1.5em")};
  color: ${(props) => (props.color ? props.color : theme.button.primary)};
  text-align: ${(props) => (props.align ? props.align : "center")};
  background-color: ${(props) =>
    props.backgraundColor ? props.backgraundColor : null};
  background-image: ${(props) =>
    props.image ? "url(" + props.image + ")" : null};
  background-image: ${(props) =>
    props.image ? "url(" + props.image + ")" : null};
  visibility: ${(props) => (props.visibility ? props.visibility : "visible")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "normal")};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : "normal")};
  text-decoration: ${(props) =>
    props.textDecoration ? props.textDecoration : "none"};
  margin-top: 66px;
`;

export const ContainerLogo = styled.div`
  display: flex;
  justify-content: ${({ positionLogo }) => positionLogo};
  padding: 0 25px;
`;

export const StylefooterSurvey = styled.div`
  -webkit-align-self: ${(props) => (props.align ? props.align : "center")};
  -ms-flex-item-align: ${(props) => (props.align ? props.align : "center")};
  font-weight: bold;
  font-size: ${(props) => (props.size ? props.size : "0.7em")};
  color: ${(props) => (props.color ? props.color : " rgba(255 255 255)")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  background-color: ${(props) =>
    props.backgraundColor ? props.backgraundColor : null};
  background-image: ${(props) =>
    props.image ? "url(" + props.image + ")" : null};
  background-image: ${(props) =>
    props.image ? "url(" + props.image + ")" : null};
  visibility: ${(props) => (props.visibility ? props.visibility : "visible")};
`;

export const StyledButton = styled.button`
  padding: 2px 0.7em;
  outline: 0;

  border-radius: 3px;
  border: none;

  font-size: ${(props) => (props.fontSize ? props.fontSize : "1em")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "normal")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "normal")};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : "normal")};
  text-decoration: ${(props) =>
    props.textDecoration ? props.textDecoration : "none"};

  color: ${(props) => (props.color ? props.color : props.theme.button.primary)};
  text-align: ${(props) => (props.align ? props.align : "center")};
  background-color: ${(props) =>
    props.backgraundColor ? props.backgraundColor : props.theme.button.primary};
  background-image: ${(props) =>
    props.image ? "url(" + props.image + ")" : null};
  visibility: ${(props) => (props.visibility ? props.visibility : "visible")};

  margin: 0;
  transition: transform 0.1s ease;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.secondaryPurple};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ValidationTextStyle = styled.p`
  color: #ff0000;
  text-align: left;
  margin: 6px 0px -8px 0 !important;
`;

//CONTENT FROM IMAGEN RATING
export const ContainerIteration = styled.div`
  display: flex;
  justify-content: center;
  svg {
    transition: fill 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important;
  }
  svg::hover {
    fill: blue !important;
  }
`;
export const SizeImgRating = styled.div`
  padding: 1em;
  background-color: ${(props) =>
    props?.backgroundColor ? "rgba(255,255,255,0.6)" : props.theme.neutral.gray[200]};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row-reverse;
  svg {
    height: 30px !important;
    width: 10% !important;
    cursor: pointer;
  }
  .ImageRating:hover,
  .ImageRating:hover ~ .ImageRating {
    fill: ${(props) => props.color} !important;
  }
`;

//CONTENT FROM QUESTION LIKE
export const ContainerIterationQuestionlike = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  grid-auto-rows: 5em 150px;
  background-color: ${(props) =>
    props?.backgroundColor ? "rgba(255,255,255,0.6)" : props.theme.neutral.gray[200]};
  padding: 0.4em;
`;

export const RadioSurveyLike = styled.div`
  display: inline-grid;
  grid-template-columns: (1, 1fr);
  justify-items: center;
  padding: 0.4em;

  svg {
    font-size: 35px;
  }
  input {
    transform: scale(1.3);
  }
  /* color: rgba(160,0,149,1); */
`;

//CONTENT QUESTION YES OR NOT
export const ContainerIterationYesOrNot = styled.div`
  display: grid;
  grid-template-columns: 2, 1fr;
  padding: 0.4em;
`;
export const RadioSurvey = styled.div`
  margin: 0.4rem;
  text-align: start;
  #labelRadioSurvey {
    margin: 0.3rem;
    text-transform: capitalize;
  }
  input {
    transform: scale(1.3);
    margin-right: 1em;
  }
`;

//CONTENT SMILE FACES
export const SizeFace = styled.div`
  display: inline-block;
  width: 20%;
  cursor: pointer;
  h3 {
    text-align: center;
    margin: 5px 0px 5px 0 !important;
    font-size: 0.8em;
  }
  svg {
    width: 60% !important;
    height: 2em !important;
    &:hover {
      fill: ${(props) => props.color} !important;
    }
  }
`;

//CONTENT MULTIPLE CHOICE
export const OptionsSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 0.5em;
  align-items: center;
  padding: 1em;
`;
export const OptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.8em 1fr;
  align-items: center;
  padding-right: 1em;

  label {
    padding: 5px;
    text-align: left;
    margin: 4.8px 5px 2px 4px;
  }

  input {
    transform: scale(1.3);
  }

  input[type="checkbox"]:checked {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: black;
  }
`;

export const OptionWrapperOther = styled.div`
  display: grid;
  grid-template-columns: 1.8em 1fr 3fr;
  align-items: center;
  padding-right: 1em;

  label {
    padding: 5px;
    text-align: left;
    margin: 4.8px 5px 2px 4px;
  }

  input {
    transform: scale(1.3);
  }

  input[type="checkbox"]:checked {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
  }

  input[type="text"] {
    width: 90%;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: black;
  }
`;

export const Ismandatory = styled.div`
  color: red;
  font-size: x-large;
  font-weight: 700;
`;
export const ContentMandatory = styled.div`
  display: inline-flex;
  height: auto;
  margin-bottom: 1em;
`;

//CONTENT MULTIPLECHOICE SINGLE SELECT
export const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2em 2em;
  margin-bottom: 1em;
`;

export const ShowImageContainer = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
export const DropdownOptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  padding-right: 1em;

  select {
    padding: 0.5em;
    width: 75%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
`;
export const SelectsSection = styled.div`
  display: grid;
  padding: 0.4em;
  grid-template-columns: 100%;
  grid-gap: 1em;

  label {
    font-weight: 700;
    font-size: small;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;
